import { render, staticRenderFns } from "./documentHeader.vue?vue&type=template&id=1acf30fa&scoped=true&"
import script from "./documentHeader.vue?vue&type=script&lang=js&"
export * from "./documentHeader.vue?vue&type=script&lang=js&"
import style0 from "./documentHeader.vue?vue&type=style&index=0&id=1acf30fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acf30fa",
  null
  
)

export default component.exports